import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { useIntl } from 'react-intl';
import { actions as primaryProviderDataActions } from '../../../../redux/appointmentForm/requests/primary-provider-data';
import {
  selectPrimaryProviderData,
  selectProgressCareUserId,
  selectProgressOrganizationId,
} from '../../../../redux/appointmentForm/selectors';
import {
  convertPrimaryCareProviderDataToFormOption,
  getInitialPcpFormConsiderUsPcpValue,
} from '../../../../utils/getPCPDictionaries';
import { selectPaperworkUserId } from '../../../../redux/paperwork/selectors/paperwork-get-user-details';
import { selectPaperworkAppointmentOrgId } from '../../../../redux/paperwork/selectors/paperwork-get-appointment-details';

export const usePrimaryCareProviderData = ({ isPaperworkFlow = false }) => {
  const dispatch = useDispatch();

  const organizationId = useSelector(selectProgressOrganizationId);
  const careUserId = useSelector(selectProgressCareUserId);

  const patientProfileId = useSelector(selectPaperworkUserId);
  const paperworkAppointmentOrgId = useSelector(
    selectPaperworkAppointmentOrgId,
  );

  const primaryProviderData = useSelector(selectPrimaryProviderData);

  const { formatMessage } = useIntl();

  useEffect(() => {
    dispatch(primaryProviderDataActions.clear());

    dispatch(
      primaryProviderDataActions.send({
        patientUserId: isPaperworkFlow ? patientProfileId : careUserId,
        organizationId: isPaperworkFlow
          ? paperworkAppointmentOrgId
          : organizationId,
      }),
    );
  }, []);

  const primaryProviderPreloadedData = useMemo(() => {
    if (!primaryProviderData) return null;

    return {
      pcpProviderAnswer: get(primaryProviderData, 'answer', null),
      pcpName: get(primaryProviderData, 'pcpName', null),
      considerUsPcp: getInitialPcpFormConsiderUsPcpValue(
        get(primaryProviderData, 'considerUs', null),
      ),
      pcp: convertPrimaryCareProviderDataToFormOption(
        get(primaryProviderData, 'primaryCareProvider', null),
        get(primaryProviderData, 'pcpName', null),
        formatMessage,
      ),
    };
  }, [primaryProviderData]);

  return {
    primaryProviderPreloadedData,
  };
};



// WEBPACK FOOTER //
// ./src/components/forms/PrimaryCareProviderWithExtraFieldsForm/hooks/usePrimaryCareProviderData.js